import { render, staticRenderFns } from "./t-dropdown.vue?vue&type=template&id=b775dcb8&"
import script from "./t-dropdown.vue?vue&type=script&lang=js&"
export * from "./t-dropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports